import React, { useContext } from 'react';
import { parse, format, addDays, startOfWeek } from 'date-fns';
import styles from '../../styles/calendar/Calendar.module.scss';
import { CalendarContext } from './CalendarContext';
const CalendarDays = () => {

  const { currentMonth } = useContext(CalendarContext);
  const days = [];
  let startDate = startOfWeek(parse(currentMonth, 'MMM yyyy', new Date()));
  for (let i = 0; i < 7; i++) {
    days.push(
      <div className={styles['daysCol']} key={i}>
        {format(addDays(startDate, i), 'eee')}
      </div>
    );
  }
  return <div className={styles['daysRows']}>{days}</div>;
};

export default CalendarDays;
